<div class="displayTable">
    <div class="displayTableCell">
  
      <div class="authBlock">
       
        <br><h3 class="center">Gracias por registrarte</h3>
  
        <div class="formGroup">
          <p class="text-center">Te hemos enviado un correo de verificacion a: <strong>{{user.email}}</strong>.</p>
          <p class="text-center">Por favor entra en tu correo y pincha en el enlace</p>
        </div>
        
        <!-- Calling SendVerificationMail() method using authService Api -->
        <div class="formGroup"class="center">
          <button type="button" class="btn btnPrimary" (click)="authService.SendVerificationMail()">
            <i class="fas fa-redo-alt"></i>
            No me ha llegado nada, <b>reenviame el correo</b>
        </button>
        </div>
  
      </div>
  
      <div class="redirectToLogin" class="center">
        <span>Te has autentificado?<span class="redirect" (click)="sendTo('auth/login')"> <b>Inicia sesión!</b></span></span>
      </div>
  
    </div>
  </div>